import { exerciseStatsQueryOptions } from '@/src/queries/activity-queries'
import { useSuspenseQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { StatisticsMetricCard } from '../StatisticsMetricCard'
import { STATISTICS_CARD_PLACEHOLDER_VALUE } from './statistics-card.constants'

export function CurrentStreakMetricCard() {
  const { t } = useTranslation(['statistics', 'common'])
  const exerciseStatsQuery = useSuspenseQuery(exerciseStatsQueryOptions)
  const currentStreakWeeks = exerciseStatsQuery.data.streak
  const value =
    currentStreakWeeks == null
      ? STATISTICS_CARD_PLACEHOLDER_VALUE
      : `${currentStreakWeeks} ${t('statistics:week_unit', {
          count: currentStreakWeeks,
        })}`

  return (
    <StatisticsMetricCard
      id="current-streak"
      title={t('statistics:metric_current_streak_title')}
      value={value}
      timeframe={t('statistics:timeframe_activity_goal_reached')}
      iconName="current-streak"
    />
  )
}
